import React, { useState, useEffect, Fragment } from "react";
import { DeleteOutlined, PlusCircleFilled } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import {
  Layout,
  Space,
  Button,
  Checkbox,
  Popconfirm,
  PageHeader,
  message,
  Input,
} from "antd";
import { red } from "@ant-design/colors";
import R2Footer from "../../../components/Footer";
import EmployeeService from "../../../services/EmployeeService";
import styles from "./EmployeeType.module.scss";

const { Content } = Layout;

const EmployeeList = () => {
  const [employeeTypes, setEmployeeTypes] = useState([
    {
      name: "Server",
      pos: true,
      deliver: true,
    },
  ]);
  const [employees, setEmployees] = useState([]);

  const deleteEmployee = async (id) => {
    try {
      await EmployeeService.deleteEmployee(id);
      setEmployees((employees) => employees.filter((e) => e.id !== id));
    } catch (error) {
      message.error(
        "Error creating employee. Please check your input and try again."
      );
    }
  };

  useEffect(() => {
    // getEmployees();
  }, []);

  const getEmployees = async () => {
    const data = await EmployeeService.getEmployees();
    setEmployees(data.employees);
  };

  return (
    <Layout className="u-page-layout">
      <Content className="w-full page-padding">
        <Space className="w-full" direction="vertical">
          <PageHeader
            title="Employee Types"
            className="page-header"
            extra={[
              <Button
                type="link"
                onClick={() => {
                  setEmployeeTypes(
                    employeeTypes.concat({
                      name: "",
                      pos: false,
                      deliver: false,
                    })
                  );
                }}
              >
                Add type <PlusCircleFilled />
              </Button>,
            ]}
          />
          <div className="site-layout-background">
            <table className="w-full">
              <thead className={styles.tHead}>
                <th>Type Name</th>
                <th>Can access POSe</th>
                <th>Can Deliver</th>
                <th>Action</th>
              </thead>
              <tbody>
                {employeeTypes.map((et, i) => (
                  <Fragment key={et.name + i}>
                    <tr>
                      <td>
                        <div className="p-1">
                          <Input
                            placeholder="Enter name"
                            name="name"
                            value={et.name}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="p-1">
                          <Checkbox checked={et.pos}></Checkbox>
                        </div>
                      </td>
                      <td>
                        <div className="p-1">
                          <Checkbox checked={et.deliver}></Checkbox>
                        </div>
                      </td>
                      <td>
                        <Popconfirm
                          title="Sure to delete?"
                          onConfirm={() => deleteEmployee()}
                        >
                          <DeleteOutlined
                            className="ml-1"
                            style={{ color: red[5] }}
                          />
                        </Popconfirm>
                      </td>
                    </tr>
                  </Fragment>
                ))}
              </tbody>
            </table>
          </div>
          <Button type="primary">Save</Button>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

export default EmployeeList;
